import React from 'react';
import Lottie from 'lottie-react';

import {Text} from '@albert-io/atomic';

import studentBgOutline from './assets/student_bg_outline.svg';
import starAnimation from './assets/star_animation.json';
import zuriAnimation from './assets/zuri_reading_book_animation.json';

export default function SignUpStudentPanel() {
  return (
    <div className='relative flex h-full min-h-[calc(100vh-60px)] flex-col overflow-hidden'>
      <div
        aria-hidden='true'
        className='inset-0 pointer-events-none absolute h-full w-full [background-blend-mode:normal,soft-light,normal] [background:linear-gradient(173deg,rgba(0,0,0,0)_76.18%,rgba(0,0,0,0.2)_94.28%),radial-gradient(268.48%_70.16%_at_53.25%_58.77%,rgba(0,0,0,0)_0%,rgba(0,0,0,0.7)_100%),linear-gradient(180deg,#0E7FC7_0%,#0094F2_100%)]'
      />

      <div
        aria-hidden='true'
        className='pointer-events-none absolute bottom-x0 h-[18%] w-full bg-[#0063CB] opacity-60'
      />

      <img
        src={studentBgOutline}
        alt=''
        aria-hidden='true'
        className='inset-0 pointer-events-none absolute h-full w-full scale-125 object-cover opacity-25'
      />

      <div className='absolute bottom-[calc(18%-6px)] left-1/2 flex -translate-x-1/2 flex-col items-center gap-x6'>
        <div className='relative flex flex-col gap-x1 text-center'>
          <div className='absolute top-[-68px] left-[-90px]'>
            <Lottie animationData={starAnimation} loop />
          </div>
          <Text className='text-xxl' bold color='primary-inverse'>
            Did you know...
          </Text>
          <Text className='max-w-[32ch] text-xxl' bold color='primary-inverse'>
            90% of students who answered 200+ questions in an AP question bank on Albert scored a 4
            or 5
          </Text>
          <div className='absolute -right-x11 -bottom-x15'>
            <Lottie animationData={starAnimation} loop />
          </div>
        </div>

        <div className='relative'>
          <Lottie animationData={zuriAnimation} loop />
          <div className='absolute bottom-x0 -left-x15'>
            <Lottie animationData={starAnimation} loop />
          </div>
        </div>
      </div>
    </div>
  );
}
